import { useCan } from "components";
import { useTypedQuery } from "hooks";
import { ACL_ACTIVITIES, ACL_RESOURCES, type PublicAccountLog } from "models";
import { AccessKeysDashboardQueryKeys } from "modules/AccessKeysDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

const sortLogs = (logs: PublicAccountLog[]) => logs.toSorted((a, b) => (a.created_on > b.created_on ? -1 : 1));

export const useLogsQuery = (publicAccountId: number | null) => {
  const canListLogs = useCan(ACL_ACTIVITIES.List, ACL_RESOURCES.PublicAPILogs);

  return useTypedQuery({
    queryKey: AccessKeysDashboardQueryKeys.logs,
    queryFn: async ({ baseUrl, endpoint }) => {
      if (!publicAccountId) return [];

      return (await ApiInstance.post(endpoint, { public_account_id: publicAccountId }, baseUrl)).data.account_logs;
    },
    select: sortLogs,
    enabled: canListLogs && Boolean(publicAccountId)
  });
};
